import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20with%20dramatic%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20luxurious%20atmosphere%2C%20empty%20theater%20seats%2C%20warm%20ambient%20glow%2C%20elegant%20classic%20cinema%20interior&width=1600&height=600&seq=cta-bg-1&orientation=landscape"
        alt="蘑菇影视 - 开启高清观影之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/60"></div>
      <div className="relative px-4 md:px-6 lg:px-8">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
              即刻开启高清观影之旅
            </h2>
            <p className="text-sm md:text-base text-foreground-300 mb-6 max-w-md leading-relaxed">
              加入蘑菇影视，畅享50000+部高清影视资源，4K蓝光画质、无广告纯净体验、流畅不缓冲，一切尽在掌握。
            </p>
            <div className="flex items-center gap-3">
              <Link
                to="/category/movie"
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-foreground-50 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即观影
              </Link>
              <Link
                to="/about"
                className="px-6 py-2.5 border border-foreground-300/40 hover:border-foreground-200 text-foreground-200 hover:text-foreground-50 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-8 flex-wrap justify-center">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">1000万+</div>
              <div className="text-xs text-foreground-400 mt-1">全球用户</div>
            </div>
            <div className="w-px h-10 bg-foreground-300/20 hidden sm:block" />
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">50000+</div>
              <div className="text-xs text-foreground-400 mt-1">影视资源</div>
            </div>
            <div className="w-px h-10 bg-foreground-300/20 hidden sm:block" />
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">98.5%</div>
              <div className="text-xs text-foreground-400 mt-1">用户好评</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}